<!-- 帮助文档 -->
<template>
  <div class="help-document">
    <gat-head></gat-head>
    <div class="help-center clearfix">
      <!-- 左侧导航菜单 -->
      <div class="help-left">
        <h2 class="title">积木盒子</h2>
        <ul>
          <li
            v-for="item in blocksTypes"
            :key="item.name"
            :class="['item', navState === item.type ? 'active' : '']"
            @click="navClick(item.type)"
          >
            <span>{{ item.name }}</span>
          </li>
          <hr />
        </ul>
      </div>
      <!-- 右侧主内容 -->
      <ai-introduce-page
        v-show="navState === 'AiIntroduce'"
      ></ai-introduce-page>

      <help-document-page
        v-show="navState !== 'AiIntroduce'"
        :currentHelp="currentHelp"
        :hashId="hashId"
      ></help-document-page>
    </div>
  </div>
</template>

<script>
import AiIntroducePage from './AiIntroducePage.vue'
import HelpDocumentPage from '../HelpDocumentPage.vue'
import HelpData from './BaseBlockEditorHelp'
// import Blockly from '@/assets/blockly/renderers/index.js'

export default {
  name: 'BaseBlockHelpDocument',
  components: {
    AiIntroducePage,
    HelpDocumentPage,
  },

  data() {
    return {
      currentHelp: [],
      scrollTop: 0,
      navState: 'AiIntroduce',
      navStateName: '',
      hashId: 'Events',
      blocksTypes: [
        { name: 'AI Training编辑器介绍', type: 'AiIntroduce' },
        { name: '事件 (Events)', type: 'Events' },
        { name: '控制 (Control)', type: 'Control' },
        { name: '运算 (Operators)', type: 'Operators' },
        { name: '字符串 (Text)', type: 'Text' },
        { name: '列表 (List)', type: 'List' },
        { name: '字典 (Dictionary)', type: 'Dictionary' },
        { name: '变量 (Variable)', type: 'Variable' },
        { name: '函数 (Function)', type: 'Function' },
        { name: '媒体 (Media)', type: 'Media' },
        { name: '海龟动作 (TurtleMotion)', type: 'TurtleMotion' },
        { name: '画笔控制 (TurtleControl)', type: 'TurtleControl' },
        { name: '海龟状态 (TurtleStatus)', type: 'TurtleStatus' },
        { name: '海龟窗口 (TurtleScreen)', type: 'TurtleScreen' },
      ],
      // toolList: [], // 接口返回模型列表
      // filterToolList: [], // 过滤返回模型列表
      blocksId: '',
      // defaultProps: {
      //   children: 'children',
      //   label: 'blocksName',
      // },
    }
  },
  watch: {},

  mounted() {
    let navStateName = window.location.search.split('=')[1] || 'AiIntroduce'
    this.navStateName = navStateName
    this.blocksId = navStateName.replace(/-/g, '')
    if (this.blocksId) {
      this.navClick(this.blocksId)
    }
  },

  methods: {
    onHashId(val) {
      this.hashId = val
    },
    onNavState(val) {
      this.navClick(val)
    },
    navClick(val) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.navState = val
      if (val === this.navStateName) {
        this.hashId = window.location.hash.split('#')[1]
      }
      if (val != 'AiIntroduce') {
        this.currentHelp = HelpData[val]
      }
    },
  }, //methods end
}
</script>

<style lang="scss" scoped>
.help {
  &-document {
    background: #f2f5fc;
  }
  &-center {
    width: 1200px;
    margin: 0 auto;
    padding-top: 120px;
    box-sizing: border-box;
  }
  &-left {
    position: fixed;
    // width: 20%;
    min-width: 220px;
    // height: 100%;
    margin-right: 10px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);
    height: 85%;
    overflow-x: hidden;
    overflow-y: auto;

    .title {
      line-height: 60px;
      font-size: 16px;
      color: #333;
      text-align: center;
    }
    .item {
      border-left: 3px solid transparent;
      text-indent: 17px;
      font-size: 14px;
      color: #333;
      line-height: 40px;
      cursor: pointer;
      // &:hover,
      &.active {
        color: #4c88ff;
        border-left: 3px solid #4c88ff;
        background: #dfeaff;
      }
      &:hover {
        color: #4c88ff;
        background: #f0f4ff;
      }
      a {
        font-size: 14px;
        color: #333;
      }
    }
  }
}
.help-document .gat-head {
  width: 100%;
  position: fixed !important;
  top: 0;
  z-index: 3;
  box-sizing: border-box;
}

.help-document {
  ::v-deep .el-tree-node__content {
    height: 40px;
    border-left: 3px solid transparent;
    text-indent: 17px;
    font-size: 14px;
    color: #333;
    line-height: 40px;
    cursor: pointer;
    &:hover,
    &.active {
      // border-left: 3px solid #4c88ff;
      // background: #dfeaff;
      color: #4c88ff;
    }
  }
  ::v-deep .el-tree-node.is-current > .el-tree-node__content {
    background: #f0f4ff;
    border-left: 3px solid #4c88ff;
    color: #4c88ff;
    font-weight: bold;

    // border-left: 3px solid #4c88ff;
    // background: #dfeaff;
  }
  ::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
    width: 10px;
    height: 10px;
  }
  ::v-deep.el-tree-node__content {
    text-indent: 0;
  }
}

.clearfix:after {
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
  content: '';
}
</style>
